import { Sprite } from 'pixi.js';
export function createTextureSpriteMap(textureMap, name) {
    return Object.fromEntries(Object.entries(textureMap).map(([type, texture]) => {
        const sprite = new Sprite(texture);
        sprite.visible = false;
        sprite.anchor.set(0.5, 0.5);
        sprite.name = `${name} (${type})`;
        return [type, sprite];
    }));
}
export function setHighlightSpriteVisibility(types, activeHighlightType) {
    Object.entries(types).forEach(([textureHighightType, sprite]) => {
        if (textureHighightType === activeHighlightType) {
            sprite.visible = true;
            return;
        }
        sprite.visible = false;
    });
}
